<!-- ==============================
  File Name: PrepayList.vue
  Description: Prepay List page
  -------------------------------
=============================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Year</label>
          <v-select :options="years" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="yearFilter" class="mb-4 md:mb-0"  @input="getFilter"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Month</label>
          <v-select :options="months" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="monthFilter" class="mb-4 md:mb-0" @input="getFilter"/>
        </div>
        <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full" v-if="!isPartner">
          <label class="text-sm opacity-75">Partner</label>
          <v-select :options="partners" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="partnerFilter" class="mb-4 md:mb-0" />
        </div> -->
      </div>
    </vx-card>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ prepays.length === 0 ? 0 : currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ prepays.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : prepays.length }} of {{ prepays.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
          <!-- ACTION - DROPDOWN -->
          <vs-button @click.prevent="redirectToAddPrepay" v-if="!isPartner">Add Prepay</vs-button>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="prepayData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import "@/assets/css/main.css";
import PartnerService from "@/services/PartnerService";
import PrepayService from "@/services/PrepayService";
import UtilService from "@/services/UtilService";
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from 'moment'
// Store Module
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";

// Cell Renderer
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererDate from '@/views/apps/prepay/cell-renderer/CellRendererDate'

import CellRendererActions from './cell-renderer/CellRendererActions.vue'

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererStatus,
    CellRendererDate,
    CellRendererActions
  },
  data () {
    return {
      userInfo : {},
      userZone: '',
      // Filter Options
      searchQuery: '',
      months: UtilService.getMonthsList(),
      partners: [],
      partnerFilter: { label: 'All', value: 'All' },
      monthFilter: { label: 'All', value: 'All' },
      yearFilter: { label: 'All', value: 'All' },
      years: UtilService.getYearsList(),
      months: UtilService.getMonthsList(),

      // AgGrid
      prepays: [],
      isPartner:false,
      currentPrepays: [],
      totalRecordCount: 0,
      gridApi: null,
      gridOptions: {
        onFilterChanged: (event) => { 
          this.totalRecordCount = (this.prepays && this.prepays.length === event.api.paginationGetRowCount())? this.prepays.length : event.api.paginationGetRowCount()
        },
        onGridReady(params) {
          this.gridApi = params.api;
          this.columnApi = params.columnApi;
          this.gridApi.sizeColumnsToFit();
          window.onresize = () => {
            this.gridApi.sizeColumnsToFit();
          }
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Date',
          field: 'PaidDate',
          filter: 'agDateColumnFilter',
          width: 280,
          cellRendererFramework: "CellRendererDate",
          filter: true,
        },
        {
          headerName: 'Partner',
          field: 'Partner',
          filter: true,
          width: 350
        },
        {
          headerName: 'Amount',
          field: 'Amount',
          filter: true,
          width: 200
        },
        {
          headerName: "Status",
          field: "IsHidden",
          filter: true,
          width: 200,
          cellRendererFramework: "CellRendererStatus",
          sortable: true
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions"
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererStatus,
        CellRendererDate,
        CellRendererActions
      }
    }
  },
  computed: {
    prepayData () {
      return this.prepays
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    getFilterParams() {
      return this.filterParams;
    },
    filterByDate(start, end) {
      if(!start || !end){
        this.prepays = [...this.currentPrepays];
      } else {
        const sd = new Date(start).getTime();
        const ed = new Date(end).getTime();
        var newPrePays = this.currentPrepays.filter((d) => {
          d['PaidDate'] = d['PaidDate'] ? UtilService.convertUTCToCurrentZone(d['PaidDate'],this.userZone) : ""
          var time = new Date(d['PaidDate']).getTime();
          return (sd <= time && time <= ed);
        });      
        this.prepays = [...newPrePays];
      }
    },
    filterByMonth(month){
      var newPrePays = this.currentPrepays.filter((d) => {
        d['PaidDate'] = d['PaidDate'] ? UtilService.convertUTCToCurrentZone(d['PaidDate'],this.userZone) : ""
        var mnth = new Date(d['PaidDate']).getMonth()+1
        return (mnth == month);
      });      
      this.prepays = [...newPrePays];
    },
    setColumnFilter (column, val, type) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null
      if (val !== 'All') {
        modelObj = { type: (type)? type : 'contains', filter: val }
      }
      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.monthFilter = this.yearFilter = this.partnerFilter = { label: 'All', value: 'All' }
      this.$refs.filterCard.removeRefreshAnimation()
      this.getPrepays();
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    redirectToAddPrepay() {
      this.$router.push("/apps/prepay/add");
    },
    getPrepays() {
      if (this.userInfo) {
        PrepayService.getAll(this.userInfo).on("value", items => {
          let Prepays = [];
          this.prepays = [];
          let index1 = 0;
          items.forEach(item => {
            let key = item.key;
            let data = item.val();
            let pastDate = new Date(new Date().setDate(new Date().getDate() - 30));
            if (data["IsDeleted"] == 0 && (UtilService.userIsAdminOrManager(this.userInfo.Role) || (!UtilService.userIsAdminOrManager(this.userInfo.Role) && data["IsHidden"] == 0))) {
              data['PaidDate'] = data['PaidDate'] ? UtilService.convertUTCToCurrentZone(data['PaidDate'],this.userZone) : ""
              PartnerService.getPartnerById(data['Partner']).on ( "value", items => {
                items.forEach(item => {
                  let partner = item.val();
                  data['PartnerId'] = data['Partner'];
                  data['Partner'] = partner['CompanyName'];
                })
                index1++;
                Prepays.push({ ...data });
                if(index1 >= items.numChildren()){
                  this.prepays = Prepays.sort(function(a, b) {
                    return new Date(b.ModifiedDate).getTime() - new Date(a.ModifiedDate).getTime();
                  });
                  this.currentPrepays = [...this.prepays];
                  this.totalRecordCount = this.prepays.length;
                }
              })
            }
          });
        });
      }
    },
    getPartnerList(){
      PartnerService.getAll(this.userInfo).on("value", (items) => {
      this.partners = [];
      this.totalActivePartnerCount = 0,
      this.partners.push({'label': 'All', 'value': 'All'})
      items.forEach((item) => {
        let partnerVal = {}
        let key = item.key;
        let data = item.val();
        if(data['IsDeleted'] == 0){
          partnerVal['label'] = data['CompanyName']
          partnerVal['value'] = data['Id']
          if(data['Status'] == 'Active' || data['IsActive']==1){
            this.totalActivePartnerCount += 1;
          }
            this.partners.push(partnerVal)
          }
        })
      });
    },
    getFilter(){
      var date = new Date();
      var start = Date;
      var end = Date;
      if((this.monthFilter.value != 'All') && (this.yearFilter.value != 'All')){
        start = UtilService.getFirstDayOfMonth(this.monthFilter.value, this.yearFilter.value);
        end = UtilService.getLastDayOfMonth(this.monthFilter.value, this.yearFilter.value);
      }
      else if(this.monthFilter.value === 'All' && this.yearFilter.value !== 'All'){
        start = UtilService.getFirstDayOfMonth( 1, this.yearFilter.value);
        end = UtilService.getLastDayOfMonth( 12, this.yearFilter.value );
      }
      else if(this.monthFilter.value !== 'All' && this.yearFilter.value === 'All'){
        this.filterByMonth(this.monthFilter.value);
        return;
      }
      else{
        start = end = null;
      }
      this.filterByDate(start, end);
    },
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.userZone = this.userInfo.Timezone;
    this.getPrepays();
    this.getPartnerList()
    if(this.userInfo.Role==='Partner Admin'|| this.userInfo.Role==='Partner Staff'){
      this.isPartner = true
      this.columnDefs.splice(1,1)
    }
    if(this.userInfo.Role == 'Partner Admin'){
      this.columnDefs.splice(3,1)
    }
  }
}

var filterParams = {
  comparator: function (filterLocalDateAtMidnight, cellDate) {
    var dateAsString = cellDate;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('/');
    filterLocalDateAtMidnight = new Date(filterLocalDateAtMidnight);
    cellDate = new Date(cellDate);

    if (filterLocalDateAtMidnight === cellDate) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
  },
  browserDatePicker: true,
  minValidYear: 2000,
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
